import { render, staticRenderFns } from "./CardEditAccess.vue?vue&type=template&id=1025c85f&scoped=true&"
import script from "./CardEditAccess.vue?vue&type=script&lang=js&"
export * from "./CardEditAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1025c85f",
  null
  
)

export default component.exports